module.exports = __webpack_public_path__ + "img/quarto-xpto.10bb54b3.jpg";